export default __webpack_public_path__ + "static/media/download-icon.96c4f5b3.svg";